var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"left"}},[_vm._v("ok")])
}
var staticRenderFns = []

export { render, staticRenderFns }